module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"reviews_count":"%{count} 条评论","review_description":"{percentage} 的用户给出了 <b>{score}</b> 分评价。"}}')
  delete Component.options._Ctor
}
